// @flow
import * as React from 'react';
import styled from 'styled-components';
import { colors, fontWeight } from '../constants';

type Props = {
  type: 'p' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'strong' | 'em',
  color?: string,
  spaced?: boolean,
  children?: React.Node,
  marginTop: number,
  fontWeight: string,
};

const defaultHeading = `
  ${fontWeight('heavy')};
  color: ${colors.darkestGrey};
  font-family: Untitled Sans, sans-serif;
`;

export const typographyStyles = {
  p: (props: Props) => ({
    'font-family': 'Untitled Sans, sans-serif',
    'font-size': '14px',
    'font-weight': fontWeight[props.fontWeight] || fontWeight.normal,
    'line-height': '20px',
    color: props.color === 'grey' ? colors.mediumGrey : colors.darkestGrey,
    'margin-bottom': props.spaced ? '20px' : 'initial',
    'margin-top': props.marginTop || 0,
  }),
  h1: defaultHeading.concat(
    `
    font-size: 22px;
    line-height: 30px;
    ${fontWeight('normal')};
  `
  ),
  h2: defaultHeading.concat(
    `
    font-size: 20px;
    line-height: 28px;
  `
  ),
  h3: defaultHeading.concat(
    `
    font-size: 16px;
    line-height: 24px;
  `
  ),
  h4: defaultHeading.concat(
    `
    font-size: 14px;
    line-height: 22px;
  `
  ),
  h5: defaultHeading.concat(
    `
    font-size: 12px;
    line-height: 20px;
  `
  ),
  strong: `
    font-family: Untitled Sans, sans-serif;
    font-size: 14px;
    ${fontWeight('heavy')};
    color: ${colors.darkestGrey};
  `,
  em: `
    font-family: Untitled Sans, sans-serif;
    font-size: 14px;
    color: ${colors.mediumGrey};
  `,
  a: `
    font-family: Untitled Sans, sans-serif;
    font-size: 14px;
    line-height: 24px;
    text-decoration: none;
    color: ${colors.mediumBlue};
  `,
};

export default class Typography extends React.Component<Props> {
  element: React$AbstractComponent<{}, Props>;

  static defaultProps = {
    marginTop: 0,
    fontWeight: '',
  };

  constructor(props: Props) {
    super(props);
    const { type } = this.props;

    // $FlowFixMe
    this.element = styled(type)([], typographyStyles[type]);
  }

  render() {
    const StyledElement = this.element;

    return <StyledElement {...this.props}>{this.props.children}</StyledElement>;
  }
}
